"use strict";

exports.__esModule = true;
exports.createPopper = void 0;
var _arrow = _interopRequireDefault(require("@popperjs/core/lib/modifiers/arrow"));
var _computeStyles = _interopRequireDefault(require("@popperjs/core/lib/modifiers/computeStyles"));
var _eventListeners = _interopRequireDefault(require("@popperjs/core/lib/modifiers/eventListeners"));
var _flip = _interopRequireDefault(require("@popperjs/core/lib/modifiers/flip"));
var _hide = _interopRequireDefault(require("@popperjs/core/lib/modifiers/hide"));
var _offset = _interopRequireDefault(require("@popperjs/core/lib/modifiers/offset"));
var _popperOffsets = _interopRequireDefault(require("@popperjs/core/lib/modifiers/popperOffsets"));
var _preventOverflow = _interopRequireDefault(require("@popperjs/core/lib/modifiers/preventOverflow"));
var _enums = require("@popperjs/core/lib/enums");
exports.placements = _enums.placements;
var _popperBase = require("@popperjs/core/lib/popper-base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// For the common JS build we will turn this file into a bundle with no imports.
// This is b/c the Popper lib is all esm files, and would break in a common js only environment
var createPopper = exports.createPopper = (0, _popperBase.popperGenerator)({
  defaultModifiers: [_hide.default, _popperOffsets.default, _computeStyles.default, _eventListeners.default, _offset.default, _flip.default, _preventOverflow.default, _arrow.default]
});